<template>
  <div>
    <div class="row">
        <div class="col-sm-6">
            <div class="mb-3">
                <select
                    id="area"
                    v-model="area"
                    class="form-select form-select-sm"
                    :disabled="areas.length < 1"
                >
                    <option :value="null">{{ $t('areas.select_area') }}</option>
                    <option
                        v-for="option in areas"
                        :key="option.id"
                        :value="option.id"
                    >
                        {{ option.name }}
                    </option>
                </select>
            </div>
        </div>

        <div class="col-sm-6">
            <div class="mb-3">
                <select
                    id="equipment"
                    class="form-select form-select-sm"
                    :value="modelValue && modelValue.id || null"
                    :disabled="areaEquipments.length < 1"
                    @change="emitChange"
                >
                    <option :value="null">{{ $t('areas.select_area_equipment') }}</option>
                    <option
                        v-for="option in equipmentOptions"
                        :key="option.id"
                        :value="option.id"
                    >
                        {{ option.name }}
                    </option>
                </select>
            </div>
        </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from "../../mixins/RestApiMixin";

export default {
    name: "AreaEquipmentSelector",
    mixins: [restApi],
    props: {
        modelValue: {
            type: Object,
            default: () => null
        },
        areaId: null
    },
    data: function () {
      return {
          area: null,
          areaEquipments: [],
          areas: [],
          loading: false
      }
    },
    computed: {
        equipmentOptions() {
            return [...this.areaEquipments]
                .sort((a, b) => {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                    return 0;
                });
        }
    },
    watch: {
        area: function () {
            if (this.area) {
                this.fetchAreaEquipment()
            } else {
                this.areaEquipments = []
                this.$emit('input', null)
            }
        }
    },
    mounted() {
        this.fetchAreas()
    },
    methods: {
        fetchAreas: function () {
            this.loading = true
            this.restFetchParams(this.areaUrl, {no_geom: 1}, this.handleAreaResults)
        },

        handleAreaResults: function (response) {
            this.loading = false
            this.areas = response && response.data ? response.data : []
            if (this.areaId && this.areas.find(item => item.id === this.areaId)) {
                this.area = this.areaId
            }
        },

        setArea: function (area) {
            this.area = area
            if (this.area) {
                this.fetchAreaEquipment()
            } else {
                this.areaEquipments = []
            }
        },

        async fetchAreaEquipment() {
            this.loading = true
            const { data: equipment } = await this.axios.get(this.areaEquipmentUrl, { params: { area: this.area } });
            this.areaEquipments = equipment;
            this.loading = false
        },

        emitChange(event) {
            const item = this.areaEquipments.find(e => e.id === parseInt(event.target.value))
            this.$emit('update:modelValue', item)
        }
    }
}
</script>
